export const CDV_DEADLINE_ISO = '2026-10-12T23:59:00-06:00'

const WHATSAPP_PHONE = '525637543320'

const whatsappLink = (message: string) =>
  `https://api.whatsapp.com/send?phone=${WHATSAPP_PHONE}&text=${encodeURIComponent(message)}`

export const CDV_ACCESS_URL = whatsappLink(
  'Hola, me interesa acceder a la Academia de Bienes Raíces...',
)

export const CDV_MONTHLY_URL = whatsappLink(
  'Hola, me interesa acceder con el plan mensual a la Academia de Bienes Raíces...',
)

export const CDV_ANNUAL_URL = whatsappLink(
  'Hola, me interesa aprovechar el descuento del plan anual a la Academia de Bienes Raíces...',
)

export const VSL_LOOM_ID = 'ea8229a2182348e5b04bea06d470c7b7'

export const testimonials = [
  {
    loomId: '8b25f1eb168d43fba0a2d810b6d26e4d',
    title: 'Cómo lograr un Millón de Dólares en 6 meses',
    name: 'Melvin',
    location: 'El Salvador',
    result: '',
  },
  {
    loomId: 'f006031d07bf4dd787ecd589c6fa369b',
    title: 'De lo empírico al desarrollo inmobiliario',
    name: 'Mariana G.',
    location: 'Bogotá',
    result: '2 Activos de Flujo en 90 días',
  },
  {
    loomId: 'f272114bfb6c4fee8746a230faa614ec',
    title: 'La expansión en Bienes Raíces',
    name: 'Domingo C.',
    location: '',
    result: '',
  },
  {
    loomId: '7d7c5b2ac6c64eaf9dd9c4ab3155db7b',
    title: 'Cómo generar expansión en Bienes Raíces',
    name: 'Yazmin',
    location: 'CDMX',
    result: '',
  },
]

export const stages = [
  {
    name: 'Ganancias de Capital',
    goal: 'Objetivo: crear liquidez.',
    description:
      'Aprendes a identificar oportunidades con alto potencial de utilidad para generar capital rápidamente.',
  },
  {
    name: 'Construcción de Rentas',
    goal: 'Objetivo: ingresos recurrentes.',
    description:
      'Una vez tienes capital, te enseñamos cómo transformarlo en activos que produzcan flujo de efectivo constante.',
  },
  {
    name: 'Altas Ganancias',
    goal: 'Objetivo: mejores operaciones.',
    description:
      'Aprendes a estructurar operaciones inmobiliarias mucho más grandes utilizando sistemas, negociación y apalancamiento.',
  },
]

export const courses = [
  'Inteligencia Artificial aplicada a los Bienes Raíces',
  'Prospección',
  'Negociación',
  'Análisis financiero',
  'Marketing inmobiliario',
  'Sistemas',
  'Automatización',
  'Escalamiento del negocio',
  'Herramientas y plantillas',
  'Recursos descargables',
]

export const liveSessionTopics = [
  'Mentalidad del inversionista',
  'Inteligencia Artificial',
  'Sistemas de Ganancias de Capital',
  'Sistemas de Altas Ganancias',
  'Sistemas de Ganancias por Rentas',
  'Cómo obtener oportunidades rentables',
  'Formas de capitalización',
  'Marketing inmobiliario',
  'Equipo mastermind',
  'Tendencias inmobiliarias',
]

export const includes = [
  {
    name: 'Metodología de 3 Etapas',
    description:
      'Cómo construir Sistemas de Ganancias de Capital, Ganancias por Renta y Sistemas de Altas Ganancias.',
  },
  {
    name: 'Contratos, Plantillas y Herramientas',
    description:
      'Los contratos, plantillas y herramientas a utilizar para proteger tu patrimonio.',
  },
  {
    name: 'Retos con premios y feedback',
    description: 'Implementa con metas claras y recibe retroalimentación.',
  },
  {
    name: 'Q&A, invitados y comunidad TOP',
    description:
      'Resuelve tus dudas en vivo y aprende de invitados expertos.',
  },
  {
    name: 'Calendario con llamadas semanales',
    description: 'Mantén el ritmo y el foco cada semana.',
  },
]

export const bonuses = [
  'Consultoría 1 a 1',
  'Test de Personalidad Financiera de Tony Robbins',
  'Acceso a oportunidades de inversión inmobiliaria para monetizar desde cero',
  'Acceso a Portafolio Inmobiliario Exclusivo',
]

export const premiumBonus = 'Consultoría 1 a 1 de Inteligencia Artificial'

export const joinSteps = [
  {
    title: 'Elige tu plan',
    description:
      'Haz clic en el botón de $47/mes o elige el plan anual con todo desbloqueado.',
  },
  {
    title: 'Crea tu cuenta de Skool',
    description:
      'Si aún no tienes cuenta, la creas en menos de un minuto e introduces tu método de pago.',
  },
  {
    title: 'Empieza hoy mismo',
    description:
      'Entra a la comunidad, comienza el primer curso y participa en las sesiones en vivo.',
  },
]

export const cdvFaqs = [
  {
    question: '¿Necesito mucho capital para empezar?',
    answer:
      'No. La Etapa 1 está diseñada precisamente para generar capital mediante la estructuración y prospección, no necesariamente usando tu propio dinero.',
  },
  {
    question: '¿Funciona en mi país?',
    answer:
      'Sí. El sistema de 3 etapas es aplicable a toda Latinoamérica. Adaptamos las estrategias de IA a los portales locales de México, Colombia, Panamá, etc.',
  },
  {
    question: '¿Cuánto tiempo le tengo que dedicar?',
    answer:
      'Con 1 hora al día enfocada en los sistemas que te enseñamos, puedes ver resultados reales. La IA hace el 80% del trabajo pesado por ti.',
  },
  {
    question: '¿Es para principiantes?',
    answer:
      'Totalmente. Vamos desde las bases hasta las estrategias más avanzadas de fideicomisos y desarrollo.',
  },
  {
    question: '¿Qué pasa si el 12 de octubre no me he inscrito?',
    answer:
      'El acceso se cerrará y la próxima vez que abramos, el precio será considerablemente mayor debido a las nuevas actualizaciones de IA que estamos agregando.',
  },
  {
    question: '¿La consultoría de IA es para todos?',
    answer: 'Es exclusiva para los miembros del Plan Anual de $247.',
  },
  {
    question: '¿Puedo cancelar cuando quiera?',
    answer:
      'Sí. No existe permanencia forzosa: puedes cancelar tu membresía cuando quieras. Tú tienes el control.',
  },
]
